// extracted by mini-css-extract-plugin
module.exports =  {"postLinkedIdea":"r4jPhWwI","postLinkedIdeaContent":"iUhFdweJ","postLinkedIdeaCounts":"ToPOhv5C","postLinkedIdeaCount":"tIBtonyj"};